<template>
  <div>
    <vxe-modal ref="modal" v-model="formVisible" title="合同模板" width="90%" height="90%" @show="showModal">
      <div class="container">
        <div class="main">
          <div class="card">
            <!-- 按钮组 -->
            <div class="toolbar-dv">
              <toolBarBtn
                @changeSearchFormShow="changeSearchFormShow"
                :buttonVisible="buttonVisible"
                :moreButtonList="moreButtonList"
                :parentData="this"
                ref="toolBarBtn"
              ></toolBarBtn>
            </div>
            <!-- 查找面板 -->
            <div class="search-dv" v-show="searchFormVisible">
              <SearchForm
                ref="SearchForm"
                v-show="searchFormVisible"
                :searchVuePath="searchVuePath"
                :menuArgs="''"
                @search="sureSearch"
              ></SearchForm>
            </div>
            <!-- 主表信息 -->
            <div class="approve-table-dv">
              <!-- 菜单明细 -->
              <div class="menu-dv" :style="{ height: this.approveCardHeight }">
                <div class="table-dv">
                  <vxe-grid
                    ref="xTable"
                    resizable
                    :column-config="{ minWidth: '80px' }"
                    :data="tableData"
                    :showOverflow="true"
                    size="mini"
                    :mouse-config="{ area: true }"
                    :tooltip-config="{
                      showAll: true,
                      theme: 'dark'
                    }"
                    :pager-config="tablePage"
                    @page-change="handlePageChange"
                    :seq-config="{
                      startIndex: (tablePage.currentPage - 1) * tablePage.pageSize
                    }"
                    highlight-hover-row
                    highlight-current-row
                    :height="tableHeight"
                    :columns="gridColumns"
                    @cell-dblclick="handleDblclick"
                    :keyboard-config="{
                      isArrow: true,
                      isEnter: true,
                      isTab: true,
                      isClip: true,
                      enterToTab: true,
                      isEdit: true
                    }"
                    :scroll-y="{
                      mode: 'wheel'
                    }"
                  >
                  </vxe-grid>
                </div>
              </div>
            </div>
          </div>
          <DetailModal ref="DetailModalRef" @updateData="refresh" />
        </div>
      </div>
    </vxe-modal>
  </div>
</template>
<script>
import DetailModal from './DetailModal.vue'
export default {
  name: 'ContractTemplate',
  components: {
    DetailModal
  },
  created() {
    this.InitColumn()
  },
  activated() {
    this.list()
  },
  data() {
    return {
      // 按钮组的可见性
      buttonVisible: {
        add: true, // 新增按钮是否显示
        update: false, // 修改按钮
        save: false, // 保存按钮是否显示
        delete: false, // 删除按钮是否显示
        refresh: true, // 刷新数据按钮是否显示
        lock: false, // 锁定按钮是否显示
        unlock: false, // 解锁按钮是否显示
        sort: false, // 排序按钮是否显示
        search: true, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      },
      // 查询条件
      searchObjects: [],
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      // 拓展按钮
      gridColumns: [],
      // 正常状态下，需要加上表格距离card上下的margin
      topBottomMargin: 20,
      formVisible: false,
      // 是否显示查询
      moreButtonList: [],
      // 查询条件vuepath
      searchFormVisible: false,
      searchVuePath: 'ContractTemplate',
      tableData: [],
      // 分页设置
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: this.tablePageConfig.defaultPageSize,
        align: 'right',
        pageSizes: this.tablePageConfig.pageSizes,
        layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
        perfect: true
      }
    }
  },
  methods: {
    openModal() {
      this.formVisible = true
    },
    // 初始化
    InitColumn() {
      this.gridColumns = [
        { type: 'seq', width: 40, fixed: 'left' },
        {
          field: 'contract_template_name',
          title: '标题'
        },
        {
          field: 'creator',
          title: '创建者'
        },
        {
          field: 'createTime',
          title: '创建时间',
          formatter: ['formatDate', 'yyyy-MM-dd HH:mm:ss']
        },
        {
          field: 'last_modify_time',
          title: '最后更新时间',
          formatter: ['formatDate', 'yyyy-MM-dd HH:mm:ss']
        }
      ]
    },
    async list() {
      const { data: res } = await this.$http.post('/Finance/Contract/Template/list', {
        pageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
        seeType: this.Authority.seeType,
        searchObjects: this.searchObjects
      })
      if (res.isSuccess) {
        this.tableData = res.data.rows
        this.tablePage.total = res.data.totals
      } else {
        this.$message.error(res.errorMessage)
        return false
      }
    },
    // 查找
    search() {
      this.searchFormVisible = !this.searchFormVisible
    },
    // 双击数据
    handleDblclick({ row }) {
      this.$refs.DetailModalRef.openModal(row.id)
    },
    // 新增
    async add() {
      this.$refs.DetailModalRef.openModal()
    },
    // 页面函数
    changeSearchFormShow() {
      this.searchFormVisible = !this.searchFormVisible
    },
    // 切换查询面板可见性
    handlePageChange({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
      this.list()
    },
    // 确认查找
    sureSearch(searchObjects) {
      this.searchObjects = searchObjects
      this.tablePage.currentPage = 1
      this.list()
    },
    // 刷新数据
    refresh() {
      this.list()
    },
    showModal() {}
  },
  computed: {
    tableHeight() {
      let isSearchForm = this.searchFormVisible
      let isToolBar = true

      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 8 : this.heightConfig.mainMargin * 6
      return this.tableHeightComputed(tableMargin + this.topBottomMargin, isSearchForm, isToolBar)
    },
    // 表格容器高度，需加上margin边距
    approveCardHeight() {
      return this.tableHeight + this.topBottomMargin
    }
  }
}
</script>
<style scoped lang="less">
.main {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}
.card {
  overflow: hidden;
}
.search-dv {
  background-color: aquamarine;
  height: 110px;
  margin: @main-margin 10px;
}

.toolbar-dv {
  padding: 10px;
}

.table-dv {
  padding: @topBottomMargin;
}

.approve-table-dv {
  display: flex;
  // 行高度，需要比 row-config 的 height 多20px，可以让内容与单元格之间有内边距
  // /deep/ .vxe-body--row {
  //   height: 80px !important;
  // }
}
// 权限菜单列表
.menu-dv {
  width: 100%;
}
</style>
